import { MutationOptions, useMutation } from "react-query";
import { APIError, APIResponse, API_URL_V3, post } from "../api";

export interface BillAirtimePurchasePayload {
  pin: string;
  phone: string;
  service_type: string;
  amount: number;
  payment_option_code: string;
  agentReference: string;
}

/**
 * Airtime purchase via the provider-agnostic bills layer (/v3/bills).
 */
function useBillAirtimePurchase(
  options?: MutationOptions<
    APIResponse<any>,
    APIError,
    BillAirtimePurchasePayload
  >
) {
  const {
    mutate: purchaseAirtime,
    isLoading: purchasingAirtime,
    isError: isPurchaseError,
    error: purchaseError,
    data: purchaseResponse,
  } = useMutation<APIResponse<any>, APIError, BillAirtimePurchasePayload>(
    (payload) =>
      post(API_URL_V3 + "/bills/airtime/purchase", payload, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }),
    options
  );

  return {
    purchaseAirtime,
    purchasingAirtime,
    isPurchaseError,
    purchaseError,
    purchaseResponse,
  };
}

export default useBillAirtimePurchase;
